import {GridWidgetFilter, ComparatorSetting} from './grid-widget-filter';
import {RestArgument} from './rest-argument';
import {TextField} from './text-field';
import { pdsUtils } from '../../pds-utils';
import { pdsI18n } from '../../pds-i18n';

export class TextFilter extends GridWidgetFilter {

  searchValue = '';

  searchValueRegex: any;

  comparator: 'CONTAINS' | 'IS_BLANK' = 'CONTAINS';

  getTagName(): string {
    return 'pds-gw-text-filter';
  }

  //
  // setup regex for text search
  //
  preFilterUpdate(): void {
    this.searchValueRegex = null;
    if (this.searchValue && this.searchValue.length > 0) {
      this.searchValueRegex = new RegExp(pdsUtils.escapeUserInput(this.searchValue), 'i');
    }
  }

  isBlank(): boolean {
    switch (this.comparator) {
      case 'IS_BLANK':
        //When the user chooses "is blank" then there is no blank option in the filter. We filter!
        return false;
      case 'CONTAINS':
      default:
        return this.searchValue == null || this.searchValue === '';
    }
  }

  internalPassesFilter(dataFromDataRow): boolean {
    switch (this.comparator) {
      case 'IS_BLANK':
        return dataFromDataRow == null || (typeof dataFromDataRow === 'string' && dataFromDataRow.trim().length === 0);
      case 'CONTAINS':
      default:
        // if it's undefined or null then do not pass
        if (dataFromDataRow == null) {
          return false;
        }

        dataFromDataRow = String(dataFromDataRow);

        if (this.searchValue && this.searchValue.length > 0 && this.searchValueRegex != null) {
          return dataFromDataRow.match(this.searchValueRegex) !== null;
        } else {
          return true;
        }
    }
  }

  setQuickSearchValue(text: string): boolean {
    this.searchValue = text;
    return this.searchValue != null && this.searchValue.length > 0;
  }

  getRestArguments(): Array<RestArgument> {
    switch (this.comparator) {
      case 'IS_BLANK':
        //This should give something like "last-name="
        return [new RestArgument(this.dataField.id, '=', '')];
      case 'CONTAINS':
      default:
        if (this.isBlank()) {
          //This returns an empty array so it will cound as nothing inside _.flatten
          return [];
        }
        return [new RestArgument(this.dataField.id, '=', this.searchValue)];
    }
  }

  previousFilter(previousFilter: GridWidgetFilter): void {
    if (previousFilter instanceof TextFilter) {
      let pFilter: TextFilter = <TextFilter>previousFilter;
      switch (pFilter.comparator) {
        case 'IS_BLANK':
          let comparatorSetting: ComparatorSetting | undefined = (<TextField>this.dataField).comparatorSettings.get('IS_BLANK');
          if (comparatorSetting != null && comparatorSetting.isVisible) {
            this.comparator = 'IS_BLANK';
            return;
          }
        case 'CONTAINS':
        default:
          this.searchValue = pFilter.searchValue;
      }
    }
  }

  getTagText(): string {
    switch (this.comparator) {
      case 'IS_BLANK':
        return pdsI18n.getText('pds|grid widget|is blank');
      case 'CONTAINS':
      default:
        return this.searchValue;
    }
  }

  getPersistenceObject(): Object | undefined {
    let state: any = {
      comparator: this.comparator,
      searchValue: this.comparator !== 'IS_BLANK' ? this.searchValue : ''
    };

    return state;
  }

  restoreFromPersistenceObject(value: Object): void {
    if (typeof value === 'string') {
      //The original getPersistenceObject() returned a string so we will continue to support that.
      this.comparator = 'CONTAINS';
      this.searchValue = <string>value;
    } else if (typeof value === 'object') {
      let state: any = value;
      let setting: ComparatorSetting | undefined = (<TextField>this.dataField).comparatorSettings.get(state.comparator);

      if (setting != null && setting.isVisible) {
        this.comparator = state.comparator;
      } else {
        this.comparator = 'CONTAINS';
      }

      this.searchValue = state.searchValue;
    }
  }
}
